module.exports = __webpack_public_path__ + "static/media/Entreprise-Direction-Travaux-Vaud.7b99fe8a.jpg";